import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { map } from 'rxjs/operators';
import { OriginUrl } from '../../../_shared/enums/originUrl.enum';
import { HelloDoctorWebSocketActions } from './../../../_shared/enums/hdWebSocketActions.enum';
import { PaperType } from './../../../_shared/enums/PaperType.enum';
import { VisitExitType } from './../../../_shared/enums/visitExitType.enum';
import { SendInvoiceNotificationInfo } from './../../../_shared/model/accounting/invoice/sendInvoiceNotificationInfo.model';
import { HdWebsocketService } from './../../../_shared/services/hd-websocket.service';
import { MfToastService } from './../../../_shared/services/mfToast.service';
import { StorageService } from './../../../_shared/services/storage.service';
import { ReservationService } from './../../pages/home/_services/reservation.service';
import { ResultService } from './../../pages/home/_services/result.service';
import { VisitService } from './../../pages/home/_services/visit.service';

@Component({
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-visitHD-exit-popup',
    templateUrl: './visitHD-exit-popup.component.html',
    styleUrls: ['./visitHD-exit-popup.component.scss'],
})
export class VisitHDExitPopupComponent implements OnInit {
    constructor(
        public activeModal: NgbActiveModal,
        private rest: ResultService,
        private storage: StorageService,
        private visitRest: VisitService,
        private reservationRest: ReservationService,
        private hdws: HdWebsocketService,
        private toast: MfToastService,
        private fb: FormBuilder,
    ) {
        this.createForm();
    }
    @Input()
    public canConcludeG100 = false;

    public selectedExit: VisitExitType;
    public term;
    public paperId;
    public surveyRestriction = true;
    public physicalExamRestriction = true;
    public formSubmited = false;
    public isG100: OriginUrl = null;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visit: any;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public reservation: any;
    public visitExitType: typeof VisitExitType = VisitExitType;
    public technicalIssuesCommentForm: FormGroup;
    public lifeStyleCommentForm: FormGroup;
    public technicalIssuesComments = [
        { comment: 'Tehnične težave' },
        { comment: 'Mladoletna oseba' },
        { comment: 'Posvet za družinskega člana oz. svojca' },
        { comment: 'Posvet za drugo osebo' },
        { comment: 'Neodzivnost' },
    ];
    public lifeStyleComments = [
        { comment: 'Strokovnjak za življenjski slog' },
        { comment: 'Strokovnjak za duševno zdravje' },
        { comment: 'Strokovnjak za prehrano' },
    ];

    ngOnInit() {
        this.getRestriction();
    }

    public warningNotify(exitType: VisitExitType): void {
        if (this.surveyRestriction && exitType == VisitExitType.HD_REFERRAL) {
            this.toast.warning('Za izbiro izhoda ustvarite izvid');
        } else if (this.physicalExamRestriction && exitType == VisitExitType.PHYSICAL_EXAM) {
            this.toast.warning('Za izbiro izhoda ustvarite izvid in pošljite termine za samostojno naročanje.');
        }
    }

    public concludeVisit() {
        this.formSubmited = true;
        if (this.selectedExit === VisitExitType.TECHNICAL_ISSUE && !this.technicalIssuesCommentForm.valid) {
            return;
        } else {
            const comment =
                this.selectedExit === VisitExitType.TECHNICAL_ISSUE
                    ? this.technicalIssuesCommentForm?.value?.concludeComment
                    : this.selectedExit === VisitExitType.LIFE_STYLE
                    ? this.lifeStyleCommentForm?.value?.concludeComment
                    : '';
            this.visitRest
                .concludeVisit(this.storage.getSelectedContractor().id, this.term.visitId, {
                    concludeStatus: this.selectedExit,
                    concludeComment: comment,
                })
                .subscribe(
                    // TODO Ignored with eslint-interactive on 2023-11-10
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    res => {
                        this.activeModal.close({
                            concludeStatus: this.selectedExit,
                            success: true,
                            data: new SendInvoiceNotificationInfo().deserialize({
                                receiver: this.term?.customer?.fullName,
                                phone: this.term?.customer?.phone?.replace(/\s/g, ''),
                                email: this.term?.customer?.email,
                            }),
                            paperId: this.paperId,
                        });
                        this.hdws.send({
                            action: HelloDoctorWebSocketActions.CALL_ENDED,
                        });
                    },
                    () => {
                        this.activeModal.close({ success: false });
                    },
                );
        }
    }

    private createForm(): void {
        this.technicalIssuesCommentForm = this.fb.group({
            concludeComment: [null, Validators.required],
        });

        this.lifeStyleCommentForm = this.fb.group({
            concludeComment: [null],
        });
    }

    public getRestriction() {
        forkJoin({
            referrals: this.rest.getCustomerPapersHistory(
                this.storage.getSelectedContractor().id,
                this.term?.customer?.id,
                PaperType.HELLODOC_REFERRAL,
            ),
            izvidi: this.rest.getCustomerPapersHistory(
                this.storage.getSelectedContractor().id,
                this.term?.customer?.id,
                PaperType.MEDIFIT_MEDICAL_REPORT,
            ),
            visitData: this.visitRest.getVisitInformation(this.storage.getSelectedContractor().id, this.term.visitId),
            reservationData: this.reservationRest.getReservation(this.storage.getSelectedContractor().id, this.term?.prereservationId),
        })
            .pipe(
                map(data => {
                    data.referrals = data?.referrals?.filter(el => el.visitId == this.term.visitId);
                    data.izvidi = data?.izvidi?.filter(el => el.visitId == this.term.visitId);
                    return data;
                }),
            )
            .subscribe(data => {
                this.visit = data.visitData;
                this.reservation = data.reservationData;
                this.isG100 = this.reservation?.originUrl;
                if (data.izvidi.length > 0) {
                    this.surveyRestriction = false;
                    // this.paperId = data.referrals[data?.referrals?.length - 1]?.paperId;
                }
                if (data.izvidi.length > 0 && data.visitData.freeslotsSent) {
                    this.physicalExamRestriction = false;
                }
            });
    }
}
